import styled from 'styled-components';
import { mqMediumMin, mqLargeMin } from 'styled/tools/media-queries';

export const Wrapper = styled.section`
  background: var(--fill-primary);
  padding: var(--spacing-16);
  overflow: scroll;
  width: 100vw;
  & > * + * {
    margin-top: var(--spacing-16);
  }

  /* Safari and Webkit browsers */
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: transparent;
    border-radius: 4px;
    transition: all 0.2s ease;
    -webkit-transition: all 0.2s ease;
  }

  /* Firefox */
  scrollbar-width: none;
  scrollbar-color: transparent transparent;

  &:has(.marquee) {
    padding-inline: 0;
  }

  @media ${mqMediumMin} {
    padding: var(--spacing-24);

    &:has(.marquee) {
      padding-inline: 0;
    }
  }

  @media ${mqLargeMin} {
    padding: var(--spacing-32);

    &:has(.marquee) {
      padding-inline: 0;
    }
  }
`;
